module.exports = __webpack_public_path__ + "static/media/profile.2d542d8c.jpeg";